import { moduleFailed } from '../utilities/_module_failure.js';
import(`./_auto-show-cards.js`).then(module => module.init()).catch(moduleFailed('_auto-show-cards.js'));
import(`./_repel_effect.js`).then(module => module.init()).catch(moduleFailed('_repel_effect.js'));
